<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { usePipelineStore } from '../store/usePipeline';
const props = defineProps({ stages: { type: Array, default: () => [] }, accountId: { type: [String, Number], default: '' } });
const emit = defineEmits(['created']);
const store = usePipelineStore();
const vstore = useStore();
const isOpen = ref(false);
const search = ref(''); const picked = ref(null);
const nome = ref(''); const valor = ref(0); const origem = ref('Manual'); const stageId = ref('');
const saving = ref(false);
const results = computed(() => {
  try { const list = vstore.getters['contacts/getContacts'] || []; const q = search.value.toLowerCase();
    return list.filter((c) => c && c.name && (!q || c.name.toLowerCase().includes(q))).slice(0, 8); } catch (e) { return []; }
});
let t = null;
const onSearch = () => { if (t) clearTimeout(t); t = setTimeout(() => {
  try { vstore.dispatch('contacts/search', { search: search.value, page: 1, sortAttr: 'name', label: '' }); } catch (e) {}
}, 250); };
const pick = (c) => { picked.value = c; nome.value = c.name; };
const open = () => { isOpen.value = true; picked.value = null; search.value = ''; nome.value = ''; valor.value = 0; origem.value = 'Manual'; stageId.value = (props.stages[0] && props.stages[0].id) || ''; };
const close = () => { isOpen.value = false; };
const create = async () => {
  if (!picked.value) return;
  saving.value = true;
  try {
    await store.upsertLead({ contact_chatwoot_id: picked.value.id, nome: nome.value, valor: Number(valor.value) || 0, origem: origem.value, stage_id: stageId.value });
    emit('created'); close();
  } finally { saving.value = false; }
};
defineExpose({ open, close });
</script>

<template>
  <div v-if="isOpen" class="fixed inset-0 z-30 flex items-center justify-center bg-n-alpha-black1" @click.self="close">
    <div class="w-[420px] max-w-[90vw] bg-n-solid-2 rounded-xl outline outline-1 outline-n-container shadow-xl flex flex-col">
      <div class="flex items-center justify-between px-4 h-12 border-b border-n-weak">
        <span class="font-medium text-sm text-n-slate-12">Novo lead</span>
        <button class="text-n-slate-11 hover:text-n-slate-12 text-lg leading-none" @click="close">&times;</button>
      </div>
      <div class="p-4 flex flex-col gap-3">
        <div v-if="!picked" class="flex flex-col gap-2">
          <input v-model="search" placeholder="Buscar contato..." class="w-full bg-n-alpha-black2 rounded-lg px-2 py-1.5 text-sm text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand" @input="onSearch" />
          <div class="flex flex-col gap-1 max-h-48 overflow-y-auto">
            <button v-for="c in results" :key="c.id" class="text-left text-sm px-2 py-1.5 rounded-lg bg-n-solid-1 text-n-slate-12 hover:bg-n-alpha-2" @click="pick(c)">{{ c.name }}</button>
            <div v-if="!results.length" class="text-xs text-n-slate-10 px-2 py-2">Digite para buscar contatos.</div>
          </div>
        </div>
        <div v-else class="flex flex-col gap-3">
          <div class="flex items-center justify-between text-sm text-n-slate-12"><span>{{ picked.name }}</span><button class="text-xs text-n-slate-11 hover:text-n-slate-12" @click="picked = null">trocar</button></div>
          <label class="text-xs text-n-slate-11 flex flex-col gap-1">Valor (R$)<input v-model="valor" type="number" min="0" step="0.01" class="w-full bg-n-alpha-black2 rounded-lg px-2 py-1.5 text-sm text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand" /></label>
          <label class="text-xs text-n-slate-11 flex flex-col gap-1">Origem<input v-model="origem" class="w-full bg-n-alpha-black2 rounded-lg px-2 py-1.5 text-sm text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand" /></label>
          <label class="text-xs text-n-slate-11 flex flex-col gap-1">Estagio<select v-model="stageId" class="w-full bg-n-alpha-black2 rounded-lg px-2 py-1.5 text-sm text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand"><option v-for="s in stages" :key="s.id" :value="s.id">{{ s.nome }}</option></select></label>
        </div>
      </div>
      <div class="p-4 border-t border-n-weak flex gap-2 justify-end">
        <button class="text-sm px-3 py-2 rounded-lg bg-n-solid-3 text-n-slate-12" @click="close">Cancelar</button>
        <button :disabled="!picked || saving" class="text-sm px-3 py-2 rounded-lg bg-n-brand text-white hover:opacity-90 disabled:opacity-40" @click="create">Criar lead</button>
      </div>
    </div>
  </div>
</template>
